import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

import crono from "vue-crono";
Vue.use(crono);

new Vue({
    router,
    store,
    vuetify,
    render: function (h) {
        return h(App);
    },
}).$mount("#app");

store.dispatch("init");
